import * as THREE from 'three';

export class MaterialLibrary {
  readonly sand = new THREE.MeshStandardMaterial({
    color: '#c4b28a',
    roughness: 0.92,
    metalness: 0.02,
  });

  readonly wetSand = new THREE.MeshStandardMaterial({
    color: '#a6906a',
    roughness: 0.85,
    metalness: 0.05,
  });

  readonly track = new THREE.MeshStandardMaterial({
    color: '#968368',
    roughness: 0.95,
    metalness: 0.02,
    transparent: true,
    opacity: 0.28,
  });

  readonly grass = new THREE.MeshStandardMaterial({
    color: '#4a4d36',
    roughness: 0.95,
    metalness: 0.02,
  });

  readonly concrete = new THREE.MeshStandardMaterial({
    color: '#7a7c72',
    roughness: 0.82,
    metalness: 0.08,
  });

  readonly darkConcrete = new THREE.MeshStandardMaterial({
    color: '#5a5c54',
    roughness: 0.86,
    metalness: 0.06,
  });

  readonly steel = new THREE.MeshStandardMaterial({
    color: '#6e7479',
    roughness: 0.45,
    metalness: 0.62,
  });

  readonly darkSteel = new THREE.MeshStandardMaterial({
    color: '#4a4f53',
    roughness: 0.5,
    metalness: 0.55,
  });

  readonly rust = new THREE.MeshStandardMaterial({
    color: '#8c4b32',
    roughness: 0.72,
    metalness: 0.18,
  });

  readonly olive = new THREE.MeshStandardMaterial({
    color: '#4a4d36',
    roughness: 0.7,
    metalness: 0.1,
  });

  readonly darkOlive = new THREE.MeshStandardMaterial({
    color: '#363820',
    roughness: 0.75,
    metalness: 0.08,
  });

  readonly alliedGreen = new THREE.MeshStandardMaterial({
    color: '#4b5d3e',
    roughness: 0.72,
    metalness: 0.08,
  });

  readonly alliedTan = new THREE.MeshStandardMaterial({
    color: '#9c8a66',
    roughness: 0.78,
    metalness: 0.05,
  });

  readonly water = new THREE.MeshStandardMaterial({
    color: '#3a5a6e',
    roughness: 0.18,
    metalness: 0.2,
    transparent: true,
    opacity: 0.92,
  });

  readonly ember = new THREE.MeshBasicMaterial({
    color: '#ff9a3c',
  });

  readonly smoke = new THREE.MeshBasicMaterial({
    color: '#8a8a8a',
    transparent: true,
    opacity: 0.45,
  });

  readonly tracer = new THREE.MeshBasicMaterial({
    color: '#ffe680',
  });

  readonly enemyFire = new THREE.MeshBasicMaterial({
    color: '#ff4d2e',
  });

  readonly marker = new THREE.MeshBasicMaterial({
    color: '#d4a03a',
    transparent: true,
    opacity: 0.55,
  });

  readonly markerInvalid = new THREE.MeshBasicMaterial({
    color: '#c43e2c',
    transparent: true,
    opacity: 0.55,
  });

  dispose(): void {
    Object.values(this).forEach((m) => {
      if (m instanceof THREE.Material) m.dispose();
    });
  }
}
